import { lazy, memo } from 'react';
import { componentLoader } from '../../../utils/componentLoader';

const Garage = memo(lazy(() => componentLoader(() => import('../../../../pages/GarageNew'))));
const GarageOpenItem = memo(
  lazy(() => componentLoader(() => import('../../../../pages/Garage/components/GarageOpenItem'))),
);

const garageNewRoute = {
  path: '/garageNew',
  component: <Garage />,
  index: true,
  children: {
    component: <GarageOpenItem />,
  },
};
export default garageNewRoute;
